import { DrylusProvider } from '@drawbotics/react-drylus';
import {
  Controller,
  Outlet,
  onDidRender,
  state,
  useAppContext,
  useController,
} from '@tokamakjs/react';

import { AuthGuard } from './guards/auth.guard';
import { AppContext } from './types';

const AppView = () => {
  const context = useAppContext<AppContext>();
  const ctrl = useController<AppController>();

  return (
    <DrylusProvider baseColor={context.color}>
      {ctrl.canRenderOutlet ? <Outlet /> : null}
    </DrylusProvider>
  );
};

@Controller({ view: AppView })
export class AppController {
  @state public canRenderOutlet = false;

  constructor(private _authGuard: AuthGuard) {}

  @onDidRender()
  public onDidRender() {
    const canRenderOutlet = this._authGuard.canActivate();

    // Avoid endless re-renders
    if (this.canRenderOutlet !== canRenderOutlet) {
      this.canRenderOutlet = canRenderOutlet;
    }
  }
}
